// RACE LOGIC v2.1 tokenizer - mirrors backend scoring.tokenize().
// A race target is www. (first) + each middle character + .com (last).
export function tokenizeTarget(target) {
  const t = target || "";
  const tokens = [];
  let rest = t;
  if (rest.toLowerCase().startsWith("www.")) {
    tokens.push(rest.slice(0, 4));
    rest = rest.slice(4);
  }
  let tail = "";
  if (rest.toLowerCase().endsWith(".com")) {
    tail = rest.slice(-4);
    rest = rest.slice(0, -4);
  }
  for (const ch of rest) tokens.push(ch);
  if (tail) tokens.push(tail);
  return tokens;
}

// Characters completed through cursor position `pos` (for CPS / progress).
export function charsDone(tokens, pos) {
  let n = 0;
  for (let i = 0; i < pos && i < tokens.length; i++) n += tokens[i].length;
  return n;
}
